import { ApolloProvider } from "@apollo/client";
import { apolloClient, Provider } from "./common";
import MainRouter from "./pages/_router/main.router";
import { HelmetProvider } from "react-helmet-async";

const App = () => (
  <Provider>
    <HelmetProvider>
        <ApolloProvider client={apolloClient}>
          <MainRouter />
        </ApolloProvider>
    </HelmetProvider>
  </Provider>
);

export default App;
